const Line = () => {
  return <div className='w-[100%] h-[1px] bg-primary-dark/[.2] last:hidden' />
}

export default Line
